
/**
 * TemplateManager Class
 * 
 * Central Template Manager
 * 
 * 
 * @class TemplateManager
 * @constructor
 * @requires moolite 1.0.1+, mustache
 * @type Class
 * 
 */

var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Live = OCS.Live || {};
OCS.Classes.TemplateManager = new Class({
    Implements: [Events],
    class_type: "TemplateManager",
    class_name: "TemplateManager",
    stored_templates: {},
    initialize: function () {
        if (OCS.Live[this.class_name]) {
            return OCS.Live[this.class_name];
        }
        // Register the events
        OCS.Live[this.class_name] = this;

    },

    /*
     * 
     * Actions
     * 
     */

    /**
     * define_template - Defines a template for later use
     * 
     * 
     * @param {String} template_name
     * @param {Object} template_ops {template_view: "String"}
     * @returns {Boolean} - True if the template is defined, false if it is not defined
     */
    define_template: function (template_name, template_view) {
        // Check to see if we already have the template
        if (this.get_template(template_name)) {
            // We already have it, so we are not going to request again, return back a success callback if we have one
            this.template_defined(template_name);
        }
        if (template_view) {
            this.set_template(template_name, template_view);
        }
    },
    template_defined: function (template_name) {
        this.fireEvent('template_defined', [this, template_name]);
    },
    /*
     * 
     * Get / Set Methods
     * 
     */


    get_html: function (template_name, data) {
        var template = this.get_template(template_name);
        if (template) {
            return Mustache.render(template, data);
        } else {
            return "";
        }
    },

    set_template: function (template_name, template_view) {
        this.stored_templates[template_name] = template_view;
        // Cache the template for faster loading later
        Mustache.parse(template_view);
        this.template_defined(template_name);
    },
    get_template: function (template_name) {
        if (this.stored_templates.hasOwnProperty(template_name)) {
            return this.stored_templates[template_name];
        } else {
            return false;
        }
    },
    clear_template: function (template_name) {
        delete this.stored_templates[template_name];
    },
    destroy: function () {
        var keys = Object.keys(this.stored_templates);
        keys.each(function (key) {
            this.clear_template(key);
        }.bind(this));
        this.removeEvents();
    }
});

